import React from 'react';
import Head from 'next/head';
import UnLoggedLayout from '../components/auth/UnLoggedLayout';

export default function SignIn() {
  return (
    <>
      <Head>
        <title>Meit! | Iniciar sesión</title>
      </Head>
      <UnLoggedLayout />
    </>
  );
}
